// src/hooks/useTheme.ts - UPDATED
import { useContext } from "react";
// Import the refactored context
import { ThemeContext, ThemeContextType } from "@/contexts/ThemeContext";

/**
 * Custom hook to access the theme context.
 * Provides the current theme name and a function to set the theme.
 */
export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
